var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallFullscreenOni = function SvgCallFullscreenOni(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M21.978 5.63a1.8 1.8 0 0 0-1.8-1.8H3.822a1.8 1.8 0 0 0-1.8 1.8v12.74a1.8 1.8 0 0 0 1.8 1.8h16.356a1.8 1.8 0 0 0 1.8-1.8V5.63zm-1.6 0v12.74a.2.2 0 0 1-.2.2H3.822a.2.2 0 0 1-.2-.2V5.63a.2.2 0 0 1 .2-.2h16.356a.2.2 0 0 1 .2.2zm-7.42 12.24v-3.676a1.95 1.95 0 0 0-1.949-1.949H4.32v1.6h6.688a.35.35 0 0 1 .349.349v3.676h1.6z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e91e63",
    d: "m14.754 9.827 3.142-3.142a.8.8 0 0 1 1.131 0 .8.8 0 0 1 0 1.131l-3.142 3.142 1.677-.017a.8.8 0 1 1 .016 1.6l-3.637.038a.8.8 0 0 1-.207-.025.79.79 0 0 1-.359-.202l-.015-.015a.79.79 0 0 1-.202-.359.8.8 0 0 1-.025-.208l.038-3.636a.8.8 0 1 1 1.6.016l-.017 1.677z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallFullscreenOni);
export default ForwardRef;